module.exports = __webpack_public_path__ + "img/vende_tu_auto_documentos_tablet.e10eef2c.png";